import {http} from "../_helpers";

// Per-installation backend switches (app.*.enabled) - hides menu entries of features that are off.
class FeaturesService {

    get() {
        return http.get(`/features`);
    }
}

export default new FeaturesService();
